import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

export const rows = {
  title: {
    label: "Property History",
    isTitle: true
  },
  purchaseDate: {
    label: "Purchase Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "purchaseDate",
        variant: "filled",
        decimals: 2,
        monthStyle: { minWidth: "176px" },
        dayStyle: { width: "80px", marginLeft: "16px" },
        yearStyle: { width: "80px", marginLeft: "16px" }
      }
    ]
  },
  purchasePrice: {
    label: "Purchase Price",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "purchasePrice",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  developmentCost: {
    label: "Development Cost",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "developmentCost",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  capExImprovements: {
    label: "CapEx Improvements",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "capExImprovements",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  yearBuilt: {
    label: "Year Built",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "yearBuilt",
        variant: "filled"
      }
    ]
  },
  yearRenovated: {
    label: "Year Renovated",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "yearRenovated",
        variant: "filled"
      }
    ]
  }

};
